import { Link } from '@mui/material';

const mdComponents = {
  p: ({ node, children }) => <>{children}</>,
  a: ({ href, children }) => <Link href={href} target="_blank" rel="noopener">{children}</Link>,
};

export default mdComponents;
